import { useQuery, UseQueryResult } from '@tanstack/react-query';
import TagApiV2 from '../../../../../../lib/api/tag/TagApiV2';
import { TAG } from '../../../../../../constants/queryKeys';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import csReviewToastMsg from '../../../../../../constants/service/toastMsg/csReviewToastMsg';
import { GetTagListRequest } from '../../../../../../lib/api/tag/type';
import { TagsRelatedFindResponseBodyDto } from '../../../../../../types/api/tags';

type UseTagListQuery<SelectResultType> = {
  payload: GetTagListRequest;
  options?: QueryOptions<TagsRelatedFindResponseBodyDto, unknown, SelectResultType>;
};

export const useTagListQuery = <SelectResultType>({
  payload,
  options,
}: UseTagListQuery<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<TagsRelatedFindResponseBodyDto, unknown, SelectResultType>(
    [...TAG.LIST, payload],
    () => TagApiV2.getTagList(payload),
    {
      ...options,
      useErrorBoundary: true,
      suspense: true,
      meta: {
        successMessage: csReviewToastMsg.GET_REVIEW_TAG_COLUMN_TAG_LIST_REQUEST_SUCCESS,
        errorMessage: csReviewToastMsg.GET_REVIEW_TAG_LIST_REQUEST_ERROR,
      },
    },
  );
};
